import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

interface OrdersByStatus {
  inquiry: number;
  quoted: number;
  confirmed: number;
  deposit_paid: number;
  fully_paid: number;
  completed: number;
  cancelled: number;
}

interface OrdersChartProps {
  data: OrdersByStatus;
}

const STATUS_LABELS: Record<string, string> = {
  inquiry: "Inquiry",
  quoted: "Quoted",
  confirmed: "Confirmed",
  deposit_paid: "Deposit paid",
  fully_paid: "Fully paid",
  completed: "Completed",
  cancelled: "Cancelled",
};

const STATUS_COLORS: Record<string, string> = {
  inquiry: "#9ca3af",
  quoted: "#60a5fa",
  confirmed: "#34d399",
  deposit_paid: "#fbbf24",
  fully_paid: "#22c55e",
  completed: "#10b981",
  cancelled: "#ef4444",
};

export default function OrdersChart({ data }: OrdersChartProps) {
  const chartData = Object.entries(data).map(([status, count]) => ({
    status,
    label: STATUS_LABELS[status] || status,
    count,
    color: STATUS_COLORS[status] || "#6b7280",
  }));

  return (
    <div className="card">
      <h3 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">Orders by status</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={chartData}
            layout="vertical"
            margin={{ top: 5, right: 20, left: 80, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" horizontal={false} />
            <XAxis type="number" tick={{ fontSize: 12, fill: "#6b7280" }} />
            <YAxis
              type="category"
              dataKey="label"
              tick={{ fontSize: 12, fill: "#6b7280" }}
              width={75}
            />
            <Tooltip
              formatter={(value: number) => [value, "Orders"]}
              contentStyle={{
                backgroundColor: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: "8px",
              }}
            />
            <Bar dataKey="count" radius={[0, 4, 4, 0]}>
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
